      document.addEventListener("DOMContentLoaded", () => {
  const lenis = new Lenis()

function raf(time) {
  lenis.raf(time)
  requestAnimationFrame(raf)
}

requestAnimationFrame(raf)


        // Smooth anchor scrolling with Lenis
        document.querySelectorAll('a[href*="#"]').forEach((link) => {
          link.addEventListener('click', (e) => {
            const hash = link.getAttribute('href').split('#')[1];
            if (!hash) return;

            const target = document.getElementById(hash) || document.querySelector(`#${hash}`);
            if (!target) return;

            e.preventDefault();
            lenis.scrollTo(target, {
              duration: 0.5, // faster
              easing: (t) => t, // linear – no extra softness
            });
          });
          setTimeout(() => {
  ScrollTrigger.refresh();
}, 300);

        });
      });